import { render, staticRenderFns } from "./MyDesignsV3.vue?vue&type=template&id=a117e122"
import script from "./MyDesignsV3.vue?vue&type=script&lang=js"
export * from "./MyDesignsV3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports